import { HallOfFameEntry } from "../../types/api";

export function formatHallOfFameCurrency(cents: number): string {
	return `$${(cents / 100).toLocaleString("en-AU", {
		minimumFractionDigits: 0,
		maximumFractionDigits: 0,
	})}`;
}

export function formatHallOfFameDate(dateStr: string): string {
	return new Date(dateStr).toLocaleDateString("en-AU", {
		day: "numeric",
		month: "short",
		year: "numeric",
	});
}

export function formatCourseLocation(course: HallOfFameEntry["course"]): string {
	const state = course.state?.trim();
	if (state) {
		return `${course.name}, ${state}`;
	}
	return course.name;
}

export function formatHole(entry: HallOfFameEntry): string {
	if (entry.hole.hole_number > 0) {
		return `Par ${entry.hole.par}, Hole ${entry.hole.hole_number}`;
	}
	return "—";
}

export const HALL_OF_FAME_LOAD_ERROR_MESSAGE =
	"We couldn't load the Hall of Fame right now. Please try again in a moment.";
